import { Info } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CodesKindToggle } from "components/CodesKindToggle/CodesKindToggle";
import { Text } from "components/text";
import { useAnalytics } from "contexts/AnalyticsContext";
import { useProduct } from "contexts/ProductContext";
import { useCodesKind } from "hooks/useCodesKind";
import { BisacTab } from "../BisacTab/BisacTab";
import { ThemaTab } from "../ThemaTab/ThemaTab";

export const CodesTab = () => {
  const { t } = useTranslation(["productDetails"]);
  const { product } = useProduct();
  const { gaEvent } = useAnalytics();
  const productId = product?.id;
  const { kind, switchKind } = useCodesKind((fromKind, toKind) => {
    if (!productId) return;
    gaEvent({
      type: "codes_tab_kind_switched",
      payload: { book: productId, from_kind: fromKind, to_kind: toKind },
    });
  });
  const [initialKind] = useState(kind);

  useEffect(() => {
    if (!productId) return;
    gaEvent({
      type: "codes_tab_opened",
      payload: { book: productId, kind: initialKind },
    });
  }, [gaEvent, initialKind, productId]);

  return (
    <div className="flex flex-col gap-4 h-full">
      <div className="flex items-center gap-4">
        {kind === "BISAC" && (
          <span className="flex items-center gap-2 text-secondary-500">
            <Info className="size-4 shrink-0" />
            <Text as="span" variant="muted">
              {t("productDetails:bisac.readOnlyNotice")}
            </Text>
          </span>
        )}
        <div className="ml-auto h-11">
          <CodesKindToggle value={kind} onChange={switchKind} />
        </div>
      </div>
      <div className="flex-1 min-h-0">
        {kind === "BISAC" ? <BisacTab key={productId} /> : <ThemaTab />}
      </div>
    </div>
  );
};
